export const FIRST_CELL_WIDTH = '400px!important'
export const DETAIL_SINGLE_COLUMN_WIDTH = '60px!important'